import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { GroupAddSchema } from "@app/components/modals/GroupModal/groupAddSchema";
import {
  ModalProps,
  useModal,
  ModalContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
  Button,
  createModalComponent,
  DialogPortal,
} from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";
import {
  useGetStoryGroupList,
  useUpdateStoryGroup,
  useGetAccountAccessKey,
} from "@shortsworks/user-api";
import { useQueryClient } from "@tanstack/react-query";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import { CustomElement } from "react-hook-form";

interface PreviewContentProps {
  storyId: string;
}

// 팝업 열리는 부분, 닫혔을 때 모달도 닫히는 부분 필요
const PreviewContent = ({
  storyId,
  close,
}: ModalProps<PreviewContentProps>) => {
  const { data: accessKeyData, isSuccess: isSuccessGetAccessKey } =
    useGetAccountAccessKey();

  return (
    <div className="fixed top-0 left-0 z-50 w-screen h-screen flex items-center justify-center">
      {!isSuccessGetAccessKey && (
        <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
      )}
      {isSuccessGetAccessKey && (
        <shorts-works
          access-key={accessKeyData.data.accessKey}
          preview="focus"
          posting-id={storyId}
        />
      )}
    </div>
  );
};

export const PreviewModal = createModalComponent(PreviewContent);
